module.exports = __webpack_public_path__ + "img/g-ban.402088f9.jpg";